import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';

function LandingPage() {
  return (
    <div className="landing-page">
      {/* Hero Section */}
    <section className="hero-section">
        <Container>
    <Row>
    <Col>
           <h1>Are You Sure About That?</h1>
              <p className="lead">
        Validate facts, check links, and ensure accuracy in your documents with AI-powered precision.
          </p>
       <Button 
  as={Link} 
         to="/validator" 
                variant="light" 
  size="lg"
        className="me-3 mb-3"
  >
            Start Validating
            </Button>
     <Button 
      variant="outline-light" 
         size="lg"
            className="mb-3"
      onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })}
        >
       Learn More
   </Button>
        </Col>
          </Row>
        </Container>
      </section>

      {/* Features Section */}
    <section id="features" className="features-section">
        <Container>
    <Row className="text-center mb-5">
            <Col>
      <h2 className="mb-3">Why YouSureAboutThat.ai?</h2>
        <p className="text-muted">
                Our advanced AI validates your content to ensure accuracy and reliability
    </p>
            </Col>
          </Row>
   <Row>
<Col md={4} className="mb-4">
      <Card className="feature-card border-0 shadow-sm">
                <Card.Body>
             <div className="feature-icon">
               <img src="/images/DocAnalysis.png" alt="Document Analysis Icon" />
             </div>
   <Card.Title>Document Analysis</Card.Title>
  <Card.Text>
     Upload text documents and get instant validation of facts and claims with detailed information on accuracy.
  </Card.Text>
       </Card.Body>
  </Card>
  </Col>
      <Col md={4} className="mb-4">
          <Card className="feature-card border-0 shadow-sm">
       <Card.Body>
            <div className="feature-icon">
               <img src="/images/LinkVerification.png" alt="Link Verification Icon" />
             </div>
 <Card.Title>Link Verification</Card.Title>
        <Card.Text>
              Automatically check all links in your documents for validity, accessibility, and relevance.
      </Card.Text>
       </Card.Body>
        </Card>
            </Col>
        <Col md={4} className="mb-4">
  <Card className="feature-card border-0 shadow-sm">
    <Card.Body>
      <div className="feature-icon">
                 <img src="/images/AIPowered.png" alt="AI Powered Icon" />
             </div>
       <Card.Title>AI-Powered</Card.Title>
        <Card.Text>
    Leverage cutting-edge AI technology to cross-reference information against trusted sources.
    Don't get a single Model's opinion—get a second (and maybe a third) opinion!
   </Card.Text>
     </Card.Body>
            </Card>
            </Col>
      </Row>

      <Row className="mt-4">
       <Col md={4} className="mb-4">
              <Card className="feature-card border-0 shadow-sm">
             <Card.Body>
            <div className="feature-icon">
               <img src="/images/Fast.png" alt="Fast & Efficient Icon" />
             </div>
      <Card.Title>Fast & Efficient</Card.Title>
        <Card.Text>
               Get validation results in seconds with our serverless Azure Functions backend.
        </Card.Text>
 </Card.Body>
        </Card>
     </Col>
    <Col md={4} className="mb-4">
              <Card className="feature-card border-0 shadow-sm">
          <Card.Body>
                  <div className="feature-icon">
                  <img src="/images/Detailed.png" alt="Detailed Reports Icon" />
                </div>
           <Card.Title>Detailed Reports</Card.Title>
       <Card.Text>
   Receive a detailed report on factuality of the information given.
           </Card.Text>
            </Card.Body>
          </Card>
      </Col>
            <Col md={4} className="mb-4">
    <Card className="feature-card border-0 shadow-sm">
  <Card.Body>
       <div className="feature-icon">
               <img src="/images/Secure.png" alt="Secure & Private Icon" />
             </div>
  <Card.Title>Secure & Private</Card.Title>
      <Card.Text>
    Your documents are processed securely with enterprise-grade Azure infrastructure and isolated LLM models.
       </Card.Text>
   </Card.Body>
      </Card>
            </Col>
      </Row>
        </Container>
   </section>

   {/* How It Works Section */}
      <section className="py-5 bg-white">
   <Container>
          <Row className="text-center mb-5">
            <Col>
              <h2 className="mb-3">How It Works</h2>
  <p className="text-muted">
     Simple, fast, and accurate validation.  Simply upload, and review the findings.  
           </p>
    </Col>
          </Row>
          <Row className="align-items-center">
            <Col md={4} className="text-center mb-4">
       <div className="step-number">1</div>
           <h4>Upload</h4>
  <p className="text-muted">
    Upload your text document to our secure validation platform
   </p>
            </Col>
            <Col md={4} className="text-center mb-4">
<div className="step-number">2</div>
         <h4>Analyze</h4>
   <p className="text-muted">
         Our AI analyzes facts, checks links, and validates information
  </p>
     </Col>
          <Col md={4} className="text-center mb-4">
         <div className="step-number">3</div>
    <h4>Review</h4>
            <p className="text-muted">
                Get detailed results with accuracy scores and recommendations
          </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <Container>
          <Row>
   <Col>
  <h2>Ready to Validate Your Content?</h2>
       <p className="lead mb-4">
     Start checking your documents for accuracy today
        </p>
              <Button 
        as={Link} 
              to="/validator" 
   variant="light" 
      size="lg"
         >
      Get Started Now
    </Button>
            </Col>
   </Row>
        </Container>
      </section>
    </div>
  );
}

export default LandingPage;
